import { Person } from "@/models/Person";

export const PersonRequest = (argPerson) => {
  let person = argPerson.copy();

  if (!person.id) {
    delete person.id;
  }

  for (var i = 0; i < person.departments.length; i++) {
    person.departments[i] = person.departments[i].id;
  }

  if (person.closest_boss) {
    person.closest_boss = person.closest_boss.id;
  }

  person.person_competencies.map((pc) => {
    // Don't send a null value person to backend
    delete pc.person;

    if (pc.competence) {
      pc.competence = pc.competence.id;
    }
  });

  person.person_refreshers.map((pr) => {
    // Don't send a null value person to backend
    delete pr.person;

    if (pr.refresher) {
      pr.refresher = pr.refresher.id;
    }
  });

  if (person.user) {
    for (let i = 0; i < person.user.usergroups.length; i++) {
      person.user.usergroups[i] = person.user.usergroups[i].id;
    }
  }

  return person;
};

export const PersonResponse = (person) => {
  return new Person(person);
};

export const PersonsResponse = (persons) => {
  return _.orderBy(persons.map((p) => PersonResponse(p)), ["fullName"], ["asc"]);
};
